import script from "./Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=f5f93ea2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5f93ea2"]])

export default __exports__